import { Brand } from '../effect';

export const makeDateISOString = Brand.nominal<DateISOString>();
